import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

export type NotifType = "account_credentials";
export type NotifTargetFilter = "never_sent" | "all";

export interface SendAccountNotificationPayload {
    role_id: number;
    notif_type: NotifType;
    default_password?: string;
    user_ids?: number[];
    filter: NotifTargetFilter;
}

export interface SendAccountNotificationResult {
    message: string;
    total_targeted: number;
    sent: number;
    failed: number;
}

export const useSendAccountNotification = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload: SendAccountNotificationPayload) => {
            const { data } = await axiosClient.post<SendAccountNotificationResult>(
                "/users/send-account-notification",
                payload
            );
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["notification-eligible-count"] });
        },
    });
};

export interface EligibleCountParams {
    role_id: number;
    notif_type: NotifType;
    filter: NotifTargetFilter;
}

export const useNotificationEligibleCount = (params: EligibleCountParams | null) => {
    return useQuery({
        queryKey: ["notification-eligible-count", params],
        queryFn: async () => {
            if (!params) return 0;
            const { data } = await axiosClient.get<{ count: number }>("/users/notification-eligible-count", {
                params,
            });
            return data.count;
        },
        enabled: !!params,
    });
};
